import { render, staticRenderFns } from "./ColSettingsDialog.vue?vue&type=template&id=e5a357a0"
import script from "./ColSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ColSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports